import { a } from "../../firebase-config";

const Test = () => {
  a();
  return <div>Test</div>;
};

export default Test;
